import { forwardRef } from 'react';

import { Flex } from '@frontend/components';

import { TitleBlockProvider } from './utils/TitleBlockContext';

const TitleBlock = forwardRef(function TitleBlock(
  { size = 'lg', children, ...props },
  ref,
) {
  const sizes = {
    lg: {
      titleFontSize: '2xl',
      descFontSize: 'lg',
      paddingY: 0,
    },
    md: {
      titleFontSize: 'xl',
      descFontSize: 'md',
      paddingY: '0.125rem',
    },
  };

  return (
    <Flex ref={ref} direction="column" {...props}>
      <TitleBlockProvider value={{ size, sizes }}>
        {children}
      </TitleBlockProvider>
    </Flex>
  );
});

export default TitleBlock;
